<blaze-dialog [showCloseButton]="false" [showFooter]="false" [scroll]="false">
  <button icon class="icon-back" blazeIconButton (click)="returnToBuilder()">
    <mat-icon svgIcon="icon_chevron_left_16" />
  </button>

  <div title> {{ action.data.httpMethod }} {{ action.data.name }} / Body </div>

  <ng-container actions>
    <button (click)="save()" blazeBarButton="primary"> Set body </button>

    <button blazeIconButton (click)="returnToBuilder()">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </ng-container>

  <div content class="content-wrapper">
    <blaze-scroller class="content-scroller">
      <div class="editor" (focus)="focusEditorContent()">
        <div class="editor-gutter">
          <!-- For loop implementation -->
          @for (_ of [].constructor(linesCount); track $index; let lineNumber = $index) {
            <div>
              {{ lineNumber + 1 }}
            </div>
          }
        </div>
        <div class="editor-container">
          <div
            #editorContent
            (paste)="onTextPaste($event)"
            class="editor-content"
            contenteditable="true"
            spellcheck="false"
          >
          </div>
          <div class="line-highlight" [ngStyle]="highlightedLineStyles$ | async"></div>
        </div>
      </div>
    </blaze-scroller>
  </div>
</blaze-dialog>
